const toDashCase = (string) => string.toLowerCase().replaceAll(' ', '-')

const fromDashCase = (string) =>
  (string.charAt(0).toUpperCase() + string.slice(1)).replaceAll('-', ' ')

export { toDashCase, fromDashCase }
